<template>
  <div class="grid place-items-center h-screen" style="height: calc(100vh - 48px)">
    <h1 class="text-greyblue text-7xl font-bold">Positioning UI</h1>
  </div>
</template>

<script lang="ts" setup>

</script>
